'use client';

import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import {
  useReducedMotion,
  usePlaybackClock,
} from '../../collection-showcase/use-animation-clock';
export function BusinessComposer({
  placeholder: e,
  text: t,
  typing: n = !1,
  pressed: r = !1,
  className: i = '',
  token: a,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let o = t.length > 0,
    s = a !== void 0 && t.startsWith(a);
  return (
    <div className={`composer ${i}`} aria-hidden={!0}>
      <div className={'flex min-h-9 items-stretch gap-2'}>
        <span
          className={
            'text-ink ml-0.5 grid size-9 shrink-0 place-items-center self-end rounded-full'
          }
        >
          <ShowcaseIcon name={'plus'} className={'size-5'} />
        </span>
        <p
          className={
            'flex min-h-9 min-w-0 flex-1 items-center pr-1 text-[15px] leading-6'
          }
        >
          {translateShowcaseNode(
            showcaseCopy,
            o ? (
              <span
                className={'text-ink line-clamp-3 min-w-0 py-1.5 break-words'}
              >
                {translateShowcaseNode(
                  showcaseCopy,
                  s ? (
                    <React.Fragment>
                      <span className={'ref ref-amber ref-enter'}>
                        {translateShowcaseNode(showcaseCopy, a)}
                      </span>
                      {translateShowcaseNode(showcaseCopy, t.slice(a.length))}
                    </React.Fragment>
                  ) : (
                    t
                  )
                )}
                {translateShowcaseNode(
                  showcaseCopy,
                  n ? <span className={'caret'} data-blink={'true'} /> : null
                )}
              </span>
            ) : (
              <span className={'text-ink-3 truncate'}>
                {translateShowcaseNode(
                  showcaseCopy,
                  n ? <span className={'caret'} data-blink={'true'} /> : null
                )}
                {translateShowcaseNode(showcaseCopy, e)}
              </span>
            )
          )}
        </p>
        <span className={'mr-0.5 flex shrink-0 items-center gap-1 self-end'}>
          <span
            className={
              'text-ink-3 hidden size-9 place-items-center rounded-xl sm:grid'
            }
          >
            <ShowcaseIcon
              name={'mic'}
              className={'size-[18px]'}
              strokeWidth={1.7}
            />
          </span>
          <span
            className={
              'grid size-9 place-items-center rounded-full bg-[var(--primary)] text-[var(--primary-foreground)] shadow-[0_1px_2px_rgb(0_0_0/0.05)] transition-transform duration-150 ease-[var(--ease)]'
            }
            style={{
              transform: r ? 'scale(0.9)' : 'none',
            }}
          >
            <span className={'swap size-4'}>
              {translateShowcaseNode(
                showcaseCopy,
                o ? (
                  <ShowcaseIcon
                    key={'send'}
                    name={'arrowUp'}
                    className={'swap-in size-4'}
                    strokeWidth={1.9}
                  />
                ) : (
                  <ShowcaseIcon
                    key={'voice'}
                    name={'wave'}
                    className={'swap-in size-4'}
                    strokeWidth={1.8}
                  />
                )
              )}
            </span>
          </span>
        </span>
      </div>
    </div>
  );
}
export function typedText(e, t, n, r = 32) {
  return t < n
    ? ''
    : e.slice(0, Math.min(e.length, Math.floor((t - n) / r) + 1));
}
export const Zn = {
  info: (
    <React.Fragment>
      <circle cx={'10'} cy={'10'} r={'7'} />
      <path d={'M10 13.2V9.6M10 6.9h.01'} />
    </React.Fragment>
  ),
  undo: <path d={'M7.5 11.5 4 8l3.5-3.5M4 8h7.5a4 4 0 0 1 0 8H9'} />,
  redo: <path d={'M12.5 11.5 16 8l-3.5-3.5M16 8H8.5a4 4 0 0 0 0 8H11'} />,
  external: (
    <path
      d={
        'M11.5 3.5h5v5M16.5 3.5 9.5 10.5M14.5 11.5v4a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h4'
      }
    />
  ),
  download: <path d={'M10 3.5v9M6.5 9 10 12.5 13.5 9M4 16.5h12'} />,
  more: <path d={'M5 10h.01M10 10h.01M15 10h.01'} strokeWidth={2.2} />,
  inbox: (
    <path
      d={
        'M3.5 11h3.8l1.2 2h3l1.2-2h3.8M5.6 5h8.8l2.1 6v4.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V11Z'
      }
    />
  ),
  edit: (
    <path
      d={
        'M9.5 4H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-4.5M14.6 3.4a1.4 1.4 0 0 1 2 2L10 12l-2.6.6L8 10Z'
      }
    />
  ),
  refresh: (
    <path
      d={
        'M16 10a6 6 0 0 1-10.4 4.1M4 10a6 6 0 0 1 10.4-4.1M14.5 3v3h-3M5.5 17v-3h3'
      }
    />
  ),
  message: <path d={'M6.6 15.8A6.6 6.6 0 1 0 4.2 13.4L3.5 16.5Z'} />,
  filter: <path d={'M3.5 5.5h13M6 10h8M8.5 14.5h3'} />,
  pin: (
    <path
      d={'M7.5 3.5h5M8.5 3.5v4.2L6 10.5v1.5h8v-1.5l-2.5-2.8V3.5M10 12v4.5'}
    />
  ),
  sparkle: (
    <path
      d={'M10 3.5 11.4 8.6 16.5 10l-5.1 1.4L10 16.5l-1.4-5.1L3.5 10l5.1-1.4Z'}
    />
  ),
  minimize: <path d={'M4 12h4v4M16 8h-4V4M8 12l-4.5 4.5M12 8l4.5-4.5'} />,
  chevronLeft: <path d={'m12 5-5 5 5 5'} />,
  bulb: (
    <path
      d={
        'M7.6 12.2A4.6 4.6 0 1 1 12.4 12.2c-.6.5-.9 1.1-.9 1.8H8.5c0-.7-.3-1.3-.9-1.8ZM8.5 16.5h3'
      }
    />
  ),
};
export function BusinessIcon({
  name: e,
  className: t = 'size-4',
  strokeWidth: n = 1.5,
  style: r,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <svg
      viewBox={'0 0 20 20'}
      fill={'none'}
      stroke={'currentColor'}
      strokeWidth={n}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
      aria-hidden={!0}
      className={t}
      style={r}
    >
      {translateShowcaseNode(showcaseCopy, Zn[e])}
    </svg>
  );
}
export function useBusinessPlayback(e, { running: t, onDone: n }) {
  let r = useReducedMotion(),
    i = usePlaybackClock({
      duration: e,
      running: t,
      reduced: r,
    }),
    { done: a } = i;
  return (
    React.useEffect(() => {
      a && t && n();
    }, [a, t, n]),
    {
      ...i,
      reduced: r,
    }
  );
}
export function AppIcon({ className: e = 'size-4' }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <span
      aria-hidden={!0}
      className={`grid shrink-0 grid-cols-2 gap-[1.5px] rounded-[4px] bg-[color-mix(in_oklch,var(--ref-violet)_14%,var(--background))] p-[3px] ${e}`}
    >
      {translateShowcaseNode(
        showcaseCopy,
        [0, 1, 2, 3].map((e) => (
          <span
            key={e}
            className={
              'rounded-[1px] bg-[color-mix(in_oklch,var(--ref-violet)_70%,transparent)]'
            }
          />
        ))
      )}
    </span>
  );
}
